var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDemote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5675 3.45891C12.5675 3.20462 12.4679 2.96074 12.2905   2.78083C12.113 2.60103 11.8724 2.5 11.6216 2.5H8.37837C8.12752 2.5 7.88694 2.60103 7.70946 2.78083C7.53209   2.96075 7.43243 3.20463 7.43243 3.45891V4.00686H5V6.19866C5 6.48939 5.1139 6.76815 5.3166 6.97362C5.51942 7.1791   5.79441 7.29456 6.08108 7.29456H13.9189C14.2056 7.29456 14.4806 7.1791 14.6834 6.97362C14.8861 6.76814 15 6.48939   15 6.19866V4.00686H12.5676L12.5675 3.45891ZM8.24323 3.45891C8.24323 3.38332 8.30367 3.32192 8.37836 3.32192H11.6216C11.6574   3.32192 11.6918 3.33635 11.7172 3.36204C11.7425 3.38772 11.7567 3.42258 11.7567 3.45891V4.00686H8.24323V3.45891ZM6.08108   8.11657C5.69353 8.1162 5.31577 7.99364 5 7.76591V10.7193H15V7.76591C14.6842 7.99365 14.3065 8.11622 13.9189   8.11657H6.08108ZM8.6479 11.4726H11.3506V14.7603H12.7019L9.99925 17.5L7.29655 14.7603H8.6479V11.4726Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDemote);
export default __webpack_public_path__ + "static/media/UserDemote.f2237d00.svg";
export { ForwardRef as ReactComponent };